<template>
    <div style="line-height: 1;">
        <el-upload
            :action="`${$http.baseUrl}/file/upload-image/v1`"
            :with-credentials="true"
            :limit="limit"
            accept="image/jpeg, image/png"
            :multiple="limit > 1 ? true : false"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :before-upload="uploadBefore"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :file-list="fileList"
            list-type="picture-card"
        >
            <i slot="default" class="el-icon-plus"></i>
            <div v-if="tip" slot="tip" style="margin-top: 15px; color: #bac9d7;" class="el-upload__tip">
                只能上传
                <span v-for="(item, index) in type" :key="index">{{index == 0 ? '' : '、'}}{{item}}</span>
                文件，且不超过{{size}}M
            </div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt />
        </el-dialog>
    </div>
</template>

<script>
let isLoading = null; // 是否正在上传
export default {
    props: {
        // 文件列表
        files: {
            type: Array,
            default() {
                return []
            }
        },
        // 最大上传数量
        limit: {
            type: Number,
            default: 1
        },
        // 文件大小（M）
        size: {
            type: Number,
            default: 2
        },
        // 是否展示提示，适合多个组件上传时
        tip: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            dialogVisible: false, // 预览窗口是否显示
            dialogImageUrl: '', // 预览图片地址
            fileList: [], // 上传的文件列表
            type: ['jpeg', 'jpg', 'png']
        };
    },
    watch: {
        files: {
            handler(newValue) {
                this.fileList = newValue;
            }
        }
    },
    methods: {
        // 上传前
        uploadBefore(file) {
            return new Promise((resolve, reject) => {
                // 判断文件类型
                let arr = file.name.split('.');
                let suffix = arr[arr.length - 1];
                if (this.type.filter(item => item == suffix.toLowerCase()).length == 0) {
                    this.$message.error('图片格式不正确');
                    reject();
                }
                // 判断文件大小
                if (file.size > this.size * 1024 * 1024) {
                    this.$message.error(`只能上传${this.size}M以下的图片`);
                    reject();
                }
                this.isLoading = this.$loading(this.$http.loadingOption);
                resolve();
            })
        },
        // 上传成功
        uploadSuccess(response, file, fileList) {
            this.fileList = fileList;
            this.isLoading.close();
            this.$emit('image-change', this.fileList);
        },
        // 上传失败
        uploadError() {
            this.isLoading.close();
            this.$message.error('上传失败');
        },
        // 预览
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.src;
            this.dialogVisible = true;
        },
        // 文件超出限制个数
        handleExceed() {
            this.$message.error('最大上传个数：' + this.limit);
        },
        // 删除
        handleRemove(file, fileList) {
            if (this.isLoading) {
                this.isLoading.close();
            }
            this.fileList = this.fileList.filter(item => item.uid != file.uid);
            this.$emit('image-change', this.fileList);
        },
        // 父组件获取图片列表
        getImgList() {
            if (this.fileList.length > 0) {
                return this.fileList.map(item => {
                    if (item.id) {
                        return item.id;
                    } else {
                        return item.response.message.id;
                    }
                });
            } else {
                return [];
            }
        }
    }
};
</script>